import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    selector: { type: String, default: ".fa-cog.fa-spin, .queued.status, .processing.status"},
    interval: { type: Number, default: 4000 }
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.interval = setInterval(() => {
      this.checkForProcessing()
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  checkForProcessing() {
    const element = document.querySelector(this.selectorValue)

    if (element) {
      this.refreshPage(element)
    }
  }

  async refreshPage(element) {
    try {
      const row = element?.closest('tr')
      const id = row?.dataset.targetId

      const response = await fetch(window.location.pathname + '/' + id + '/refresh', {
        method: "GET",
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': this.getCSRFToken()
        },
        credentials: 'same-origin'
      })

      const jsCode = await response.text()
      eval(jsCode)
    } catch (error) {
      console.error("Error executing request:", error)
    }
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (!token) {
      console.error('CSRF token not found in page meta tags')
    }
    return token
  }
}
